import { ComponentThemeType } from './theme.types';

export const cardsTheme: ComponentThemeType = {
  MuiCard: {
    styleOverrides: {
      root: ({ theme: { palette } }) => ({
        backgroundColor: palette.tertiary.main,
        boxShadow: '0px 4px 23px rgba(0, 0, 0, 0.1)',
      }),
    },
  },
};
